import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _toPropertyKey from '@babel/runtime/helpers/toPropertyKey';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import isArray from 'lodash-es/isArray';
import PropTypes$1 from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { PropTypes } from '@panneau/core';
import { useFiltersComponents } from '@panneau/core/contexts';
import { getComponentFromName } from '@panneau/core/utils';
import Button from '@panneau/element-button';
import FormGroup from '@panneau/element-form-group';
import Icon from '@panneau/element-icon';
import Navbar from '@panneau/element-navbar';

var styles = {"select":"panneau-filter-filters-select","last":"panneau-filter-filters-last"};

var _excluded = ["component", "name", "groupLabel", "groupClassName"];
var propTypes = {
  filters: PropTypes.filters,
  value: PropTypes$1.object,
  // eslint-disable-line react/forbid-prop-types
  clearValue: PropTypes$1.object,
  // eslint-disable-line react/forbid-prop-types
  onChange: PropTypes$1.func,
  onReset: PropTypes$1.func,
  withContainer: PropTypes$1.bool,
  withReset: PropTypes$1.bool,
  withResetLabel: PropTypes$1.bool,
  defaultValue: PropTypes$1.objectOf(PropTypes$1.object),
  // eslint-disable-line react/forbid-prop-types
  className: PropTypes$1.string,
  children: PropTypes$1.node
};
var defaultProps = {
  filters: [],
  value: null,
  clearValue: null,
  onChange: null,
  onReset: null,
  withContainer: false,
  withReset: true,
  withResetLabel: false,
  defaultValue: {
    page: null
  },
  className: null,
  children: null
};
var Filters = function Filters(_ref) {
  var filters = _ref.filters,
    value = _ref.value,
    clearValue = _ref.clearValue,
    onChange = _ref.onChange,
    onReset = _ref.onReset,
    withContainer = _ref.withContainer,
    withReset = _ref.withReset,
    withResetLabel = _ref.withResetLabel,
    defaultValue = _ref.defaultValue,
    className = _ref.className,
    children = _ref.children;
  var FilterComponents = useFiltersComponents();
  var currentFilters = filters || [];
  var onFiltersReset = useCallback(function () {
    if (onReset !== null) {
      onReset(null);
    }
    if (onChange !== null) {
      onChange(null);
    }
  }, [onReset]);
  var hasActiveFilter = (currentFilters || []).reduce(function (isActive, item) {
    var activeValue = clearValue || value || null;
    if (activeValue !== null && typeof activeValue[item.name] !== 'undefined') {
      if (isArray(activeValue[item.name])) {
        return activeValue[item.name].length > 0;
      }
      return activeValue[item.name] !== null;
    }
    return isActive;
  }, false);
  var onFilterChange = useCallback(function (name, newFilterValue) {
    // console.log('change', name, newFilterValue);
    // console.log('value', value);
    if (name !== null && onChange !== null) {
      onChange(_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, name, newFilterValue), defaultValue));
    }
  }, [onChange, value, defaultValue]);
  var onFilterClear = useCallback(function (name) {
    if (name !== null && onChange !== null) {
      var _ref2 = value || {};
        _ref2[name];
        var newValue = _objectWithoutProperties(_ref2, [name].map(_toPropertyKey));
      onChange(_objectSpread(_objectSpread({}, newValue), defaultValue));
    }
  }, [onChange, value, defaultValue]);
  var withButton = withReset && hasActiveFilter && currentFilters.length > 0;
  return /*#__PURE__*/React.createElement(Navbar, {
    className: classNames(['gap-2', 'align-items-start', 'justify-content-start', _defineProperty({
      'navbar-expand-md': withContainer
    }, className, className !== null)]),
    withoutCollapse: true
  }, (currentFilters || []).map(function (_ref4, index) {
    var component = _ref4.component,
      name = _ref4.name,
      groupLabel = _ref4.groupLabel,
      groupClassName = _ref4.groupClassName,
      filterProps = _objectWithoutProperties(_ref4, _excluded);
    var FilterComponent = getComponentFromName(component, FilterComponents, null);
    var filterValue = value !== null && value[name] ? value[name] : null;
    var withSize = component === 'select' || component === 'search';
    return FilterComponent !== null ? /*#__PURE__*/React.createElement(FormGroup, {
      key: "filter-".concat(name, "-").concat(index + 1),
      label: groupLabel,
      className: classNames(['nav-item', _defineProperty(_defineProperty(_defineProperty({}, styles.select, withSize), styles.last, currentFilters.length < 3 && index === currentFilters.length - 1 && name === 'search'), groupClassName, groupClassName !== null)])
    }, /*#__PURE__*/React.createElement(FilterComponent, Object.assign({}, filterProps, {
      value: filterValue,
      onChange: function onChange(newValue) {
        return onFilterChange(name, newValue);
      },
      onClear: function onClear() {
        return onFilterClear(name);
      },
      className: component === 'select' ? 'mw-100' : null
    }))) : null;
  }), withButton && (currentFilters || []).length > 1 ? /*#__PURE__*/React.createElement(Button, {
    size: "md",
    theme: "secondary",
    outline: true,
    onClick: onFiltersReset
  }, withResetLabel ? /*#__PURE__*/React.createElement("span", {
    className: "me-2"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Tol+/U",
    defaultMessage: [{
      "type": 0,
      "value": "Clear"
    }]
  })) : null, /*#__PURE__*/React.createElement(Icon, {
    name: "x-circle"
  })) : null, children);
};
Filters.propTypes = propTypes;
Filters.defaultProps = defaultProps;

export { Filters as default };
